import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CALENDAR_MONTH_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const CalendarMonthRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CALENDAR_MONTH_ROUNDED_GLYPH} />;
